import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect } from "react";

const enum fields {
    scriptUrl = "scriptUrl",
}

interface Props extends WidgetProps {
    fields: {
        [fields.scriptUrl]: string;
    };
}

const scriptLoader: React.FC<Props> = ({ fields }) => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = fields.scriptUrl;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return <><div id="ScriptContainer"></div></>;
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.scriptUrl,
            displayName: "Script Url",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the script url",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: scriptLoader,
    definition,
};

export default widgetModule;